import { ImagePicker, Toast } from "antd-mobile";
import axios from "axios";
import React, { forwardRef, useCallback, useEffect, useState } from "react";
import instance from "../../../../../util/axios";

interface SelectItemProps {
  dictionary?: string;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  placeholder: string;
  width: string;
  children?: any;
  disabledDelete?: any;
  maxNumber?: number;
}

export default forwardRef(
  ({
    dictionary,
    value,
    onChange,
    disabled,
    placeholder,
    width,
    children,
    disabledDelete = false,
    maxNumber = 9,
  }: SelectItemProps) => {
    let isHttps = "https:" === document.location.protocol ? true : false;
    const [filesList, setFilesList] = useState<
      {
        url: string;
        uuid: string;
      }[]
    >([]);
    const imageOnChange = useCallback(
      async (files: any[]) => {
        files.forEach(async (picture: any, index) => {
          if (picture.uuid) return; //该照片已上传
          //获得配置
          const resp = await instance.post<any>(
            `/oa/common/attachment/uploadOSSConfNoCrossDomain?fileName=${picture.file.name}&category=vsheet&fileSize=${picture.file.size}&isHttps=false`
          );
          if (resp.data.Status !== "1") return;
          let formData = new FormData();
          formData.append("key", resp.data.Data.dir);
          formData.append("policy", resp.data.Data.policy);
          formData.append("OSSAccessKeyId", resp.data.Data.accessid);
          formData.append("success_action_status", "200");
          formData.append("signature", resp.data.Data.signature);
          formData.append("callback", resp.data.Data.callback);
          formData.append("category", "vsheet");
          formData.append("id", "WU_FILE_0");
          formData.append("type", "application/x-msdownload");
          formData.append("file", picture.file);
          //上传图片
          const respForImage = await axios.post<any>(
            "https://tianyiyuncom.oss-cn-beijing.aliyuncs.com",
            formData
          );
          if (respForImage.data.Status !== "1") return;
          //获取图片链接
          const DownloadOSSFileUrl = await instance.get<any>(
            `/oa/common/attachment/getDownloadOSSFileUrl?ids=${respForImage.data.Data.uuid}&isHttps=${isHttps}`
          );
          if (DownloadOSSFileUrl.data.Status === "1") {
            setFilesList((prevState) => {
              return [
                ...prevState,
                {
                  url: DownloadOSSFileUrl.data.Data[0],
                  uuid: respForImage.data.Data.uuid,
                  index: index,
                },
              ];
            });
            if (filesList && filesList.length > 0) {
              const copy = JSON.parse(JSON.stringify(filesList));
              copy.push({
                url: DownloadOSSFileUrl.data.Data[0],
                uuid: respForImage.data.Data.uuid,
                index: index,
              });
              // const res=filesList.map((prevState:any) => {
              //   return  ( ...prevState,
              //     )
              // })
              onChange(copy.map((item: any) => item.uuid).join(","));
            } else {
              const res = [
                {
                  url: DownloadOSSFileUrl.data.Data[0],
                  uuid: respForImage.data.Data.uuid,
                  index: index,
                },
              ];
              onChange(res.map((item: any) => item.uuid).join(","));
            }
          }
        });
      },
      [isHttps, filesList]
    );
    const getFilesList = useCallback(async () => {
      setFilesList([]);
      if (value && value.length > 0) {
        let arr: any = [];
        for (var i = 0; i < value.length; i++) {
          const DownloadOSSFileUrl = await instance.get<any>(
            `/oa/common/attachment/getDownloadOSSFileUrl?ids=${value[i]}&isHttps=${isHttps}`
          );
          if (DownloadOSSFileUrl.data.Status === "1") {
            arr.push({
              url: DownloadOSSFileUrl.data.Data[0],
              uuid: value[i].uuid || value[i],
              index: i,
            });
          }
        }
        setFilesList(arr);
      } else {
        setFilesList([]);
      }
    }, [isHttps, value]);

    useEffect(() => {
      getFilesList();
    }, [value, isHttps, getFilesList]);
    return (
      <>
        <ImagePicker
          style={{ backgroundColor: "#FFFFFF", flex: 1 }}
          files={filesList}
          multiple={true}
          capture={false}
          disableDelete={disabledDelete}
          selectable={disabled}
          accept="image/gif,image/jpeg,image/jpg,image/png"
          onChange={(files, operationType, deleteIndex) => {
            if (filesList?.length > maxNumber - 1 && operationType === "add") {
              Toast.show(`最大上传数为${maxNumber}!`);
              return;
            }
            if (files && operationType === "add") imageOnChange(files);
            if (deleteIndex !== undefined) {
              const copy = JSON.parse(JSON.stringify(filesList));
              setFilesList((prevState) => {
                const cloned = [...prevState];
                cloned.splice(deleteIndex, 1);
                return cloned;
              });
              copy.splice(deleteIndex, 1);
              onChange(copy.map((item: any) => item.uuid).join(","));
            }
          }}
        ></ImagePicker>
      </>
    );
  }
);
